<div *ngIf="!boxType" class="wrap {{customClass}}">
  <div class="input-wrap" [class.input-error]="control?.invalid && control?.touched" (click)="wrapClick()">
    <input #otpInputField id="otpInputField"
      [type]="isMobile ? 'tel' : 'number'"
      placeholder="Enter OTP"
      [formControl]="control"
      (focus)="focusInput(true)"
      (wheel)="$event.preventDefault()"
    />
    <div *ngIf="showResend && !control.disabled" class="resend" (click)="resend()">RESEND OTP</div>
    <div *ngIf="timer && !showResend && !control.disabled" class="resend timer">Resend in {{timer}}</div>
  </div>
  <div class="error">
    <div *ngIf="control?.hasError('required') && control?.touched" [innerHTML]="errorMessage?.required"></div>
    <div *ngIf="!control?.hasError('required') && control?.invalid && control?.touched" [innerHTML]="errorMessage?.pattern"></div>
  </div>
</div>

<div *ngIf="boxType" class="wrap">
  <div class="boxInputWrap">
    <div class="inputs">
      <input *ngFor="let ctrl of otpControls; let i = index"
        [type]="isMobile ? 'tel' : 'text'"
        maxlength="1"
        pattern="[0-9]*"
        inputmode="numeric"
        [formControl]="ctrl"
        (input)="onInput($event, i)"
        (keydown)="onKeyDown($event, i)"
        (paste)="onPaste($event)"
        #otpInput
      />
    </div>
    <div class="error">
      <div *ngIf="control?.hasError('required') && control?.touched" [innerHTML]="errorMessage?.required"></div>
      <div *ngIf="!control?.hasError('required') && control?.invalid && control?.touched" [innerHTML]="errorMessage?.pattern"></div>
    </div>
    <div *ngIf="showResend && !control.disabled" class="resend" (click)="resend()">Resend Code</div>
    <div *ngIf="timer && !showResend && !control.disabled" class="timer">Resend OTP in <strong>{{timer}}</strong></div>
  </div>
</div>